import React from 'react'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'

const StorageListingPage = React.lazy(
  () => import('@/features/estoque/pages/estoque-listar'),
)
const StorageDashboardPage = React.lazy(
  () => import('@/features/estoque/pages/estoque-painel'),
)
const StorageSupplyPage = React.lazy(
  () => import('@/features/estoque/features/transacao/pages/abastecer'),
)
const StorageTransferPage = React.lazy(
  () => import('@/features/estoque/features/transacao/pages/transferir'),
)
const StorageCheckinPage = React.lazy(
  () => import('@/features/estoque/features/transacao/pages/devolver'),
)
const StorageCheckoutPage = React.lazy(
  () => import('@/features/estoque/features/transacao/pages/retirar'),
)

export default function Component() {
  return (
    <Routes>
      <Route index element={<StorageListingPage />} />
      {/* <Route path="novo" element={<Person.Create />} /> */}
      <Route path=":storage_id" element={<Outlet />}>
        <Route index element={<StorageDashboardPage />} />
        <Route path="itens" element={<Outlet />}>
          <Route index element={<Navigate to="../" />} />
          <Route path="abastecer" element={<StorageSupplyPage />} />
          <Route path="transferir" element={<StorageTransferPage />} />
          <Route path="retirar" element={<StorageCheckoutPage />} />
          <Route path="devolver" element={<StorageCheckinPage />} />
        </Route>
      </Route>
    </Routes>
  )
}
